module.exports = __webpack_public_path__ + "img/coins-icon.67254da3.svg";